import React, {FC, forwardRef, ReactNode} from 'react'
import classnames from 'classnames'

// @ts-ignore
import {RadioButton} from '../../../icons'

// @ts-ignore
import styles from './Radio.scss'

type RadioProps = JSX.IntrinsicElements['input'] & {
  children: ReactNode
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({children, className, ...props}, ref) => {
    return (
      <label className={classnames(className, styles.radioWrapper)}>
        <input
          className='m-radio-input'
          ref={ref}
          type='radio'
          {...props}
        />
        <span className={classnames(styles.indicator, 'm-radio-parts')} />
        { children }
      </label>
    )
  }
)

type RadioContainerProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode
}

export const RadioContainer: FC<RadioContainerProps> = ({children, className, ...props}) => {
  return (
    <div
      className={classnames(className, styles.container)}
      {...props}
    >
      {children}
    </div>
  )
}
